/**************************** IMAGE UPLOAD ***************************************/
$( function() {
  $( "#CustomJacket" ).accordion({
    collapsible: true,
    heightStyle: "content"
  });
});
$(".gsrtd.btn").on('click',function() {
  $('html, body').animate({
    'scrollTop' : $(".PlusCustomForm").position().top
  });
});
$("#countries").msDropdown();
$(".cowImageForm").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.cowImageForm').prop('files')[0];
    var imageName = $('.cowImageForm').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.cowImageForm').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/images/"+ne_get_1 ;
    var formData = new FormData($("#cowcustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#cowcustom_form #cowbar").show();
            $("#cowcustom_form #cowbar").text("("+percentComplete+"%)");
            $("#cowcustom_form .cowbar_wrapper_1").show();
            $("#cowcustom_form .cowimageWrapp").css("display","none");
            $("#cowcustom_form .cowmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("cowbar").style.width=percentComplete+'%';
            document.getElementById("cowbar").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#cowcustom_form .cowimageWrapp").css("display","none");
              $("#cowcustom_form .cowmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#cowcustom_form .cowbar_wrapper_1.cowprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#cowcustom_form .cowImageForm").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#cowcustom_form").hide();
        $(".cowImagesNames").html("<span>"+imageName+",</span>");
        $("#cowcustom_form_2").show();
      }
    })
  }
})

/************** 2nd Image ********************************/
$(".cowImageForm_2").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.cowImageForm_2').prop('files')[0];
    var imageName = $('.cowImageForm_2').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.cowImageForm_2').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/images/"+ne_get_1 ;
    var formData = new FormData($("#custom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#cowcustom_form_2 #cowbar_2").show();
            $("#cowcustom_form_2 #cowbar_2").text("("+percentComplete+"%)");
            $("#cowcustom_form_2 .cowbar_wrapper_1").show();
            $("#cowcustom_form_2 .cowimageWrapp").css("display","none");
            $("#cowcustom_form_2 .cowmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("cowbar_2").style.width=percentComplete+'%';
            document.getElementById("cowbar_2").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#cowcustom_form_2 .cowimageWrapp").css("display","none");
              $("#cowcustom_form_2 .cowmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#cowcustom_form_2 .cowbar_wrapper_1.cowprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#cowcustom_form_2 .cowImageForm_2").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#cowcustom_form_2").hide();
        $("<span>"+imageName+",</span>").appendTo(".cowImagesNames");
        $("#cowcustom_form_3").show();
      }
    })
  }
})   

/************** 3rd Image ********************************/
$(".cowImageForm_3").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.cowImageForm_3').prop('files')[0];
    var imageName = $('.cowImageForm_3').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.cowImageForm_3').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/images/"+ne_get_1 ;
    var formData = new FormData($("#cowcustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#cowcustom_form_3 #cowbar_3").show();
            $("#cowcustom_form_3 #cowbar_3").text("("+percentComplete+"%)");
            $("#cowcustom_form_3 .cowbar_wrapper_1").show();
            $("#cowcustom_form_3 .cowimageWrapp").css("display","none");
            $("#cowcustom_form_3 .cowmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("cowbar_3").style.width=percentComplete+'%';
            document.getElementById("cowbar_3").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#cowcustom_form_3 .cowimageWrapp").css("display","none");
              $("#cowcustom_form_3 .cowmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#cowcustom_form_3 .cowbar_wrapper_1.cowprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#cowcustom_form_3 .cowImageForm_3").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#cowcustom_form_3").hide();
        $("<span>"+imageName+",</span>").appendTo(".cowImagesNames");
        $("#cowcustom_form_4").show();
      }
    })
  }
})

/************** 4th Image ********************************/
$(".cowImageForm_4").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.cowImageForm_4').prop('files')[0];
    var imageName = $('.cowImageForm_4').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.cowImageForm_4').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/images/"+ne_get_1 ;
    var formData = new FormData($("#cowcustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#cowcustom_form_4 #cowbar_4").show();
            $("#cowcustom_form_4 #cowbar_4").text("("+percentComplete+"%)");
            $("#cowcustom_form_4 .cowbar_wrapper_1").show();
            $("#cowcustom_form_4 .cowimageWrapp").css("display","none");
            $("#cowcustom_form_4 .cowmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("cowbar_4").style.width=percentComplete+'%';
            document.getElementById("cowbar_4").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#cowcustom_form_4 .cowimageWrapp").css("display","none");
              $("#cowcustom_form_4 .cowmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#cowcustom_form_4 .cowbar_wrapper_1.cowprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#cowcustom_form_4 .cowImageForm_4").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        console.log("RIGHT SUBMIT");
        $("#cowcustom_form_4").hide();
        $("<span>"+imageName+",</span>").appendTo(".cowImagesNames");
        $("#cowcustom_form_5").show();
      }
    })
  }
})

/************** 5th Image ********************************/
$(".cowImageForm_5").change(function(){
  var image_size = (this.files[0].size);
  var ext = $(this).val().split('.').pop().toLowerCase();
  if($.inArray(ext, ['psd','pdf','png','jpg','jpeg','doc','docx']) == -1) {
    alert('Invalid extension!');
    $(this).val('');
  }
  else if(image_size > 15360000){
    alert('Please upload the Maximum of 15MB image.');
    $(this).val('');
  }	
  else{
    var file_data = $('.cowImageForm_5').prop('files')[0];
    var imageName = $('.cowImageForm_5').val().replace(/C:\\fakepath\\/i, '');
    var ne_get_1 = $('.cowImageForm_5').val().replace(/C:\\fakepath\\/i, '');
    ne_get_1 = "https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/images/"+ne_get_1 ;
    var formData = new FormData($("#cowcustom_form")[0]);
    formData.append('file', file_data);
    $.ajax({
      url:"https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats/upload_image.php",
      type:"POST",
      data: formData,
      cache: false,
      dataType: "json",
      contentType:false,
      processData: false,
      xhr: function() {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener("progress", function(evt) {
          if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            percentComplete = parseInt(percentComplete * 100);
            $("#cowcustom_form_5 #cowbar_5").show();
            $("#cowcustom_form_5 #cowbar_5").text("("+percentComplete+"%)");
            $("#cowcustom_form_5 .cowbar_wrapper_1").show();
            $("#cowcustom_form_5 .cowimageWrapp").css("display","none");
            $("#cowcustom_form_5 .cowmsg_uploading_1").html("Uploading.... Please wait.");
            document.getElementById("cowbar_5").style.width=percentComplete+'%';
            document.getElementById("cowbar_5").innerHTML=percentComplete+'%';
            if (percentComplete === 100) {
              $("#cowcustom_form_5 .cowimageWrapp").css("display","none");
              $("#cowcustom_form_5 .cowmsg_uploading_1").html(imageName+" Image Uploaded");
              $("#cowcustom_form_5 .cowbar_wrapper_1.cowprogress_bar").hide();
              //$("#custom_form_2").css("display","block");
              $("#cowcustom_form_5 .cowImageForm_5").attr("data-src",ne_get_1);
            }
          }
        }, false);
        return xhr;
      },
      success:function(response){
        $("<span>"+imageName+"</span>").appendTo(".cowImagesNames");
        console.log("RIGHT SUBMIT");
        $("#cowcustom_form_5").addClass("StopUpload");
      }
    })
  }
})


/****************FORM SUBMIT *********************/
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var OrderId = getCookie("OrderId");
$(".hdrbg h3 b").html(OrderId);
$(".cowbtnGtsrtd button.form-btn.btn.btn-default").click(function(){

  var nameGet = $(".cowNameForm").val();
  var emailGet = $(".cowEmailForm").val();
  var numberGet = $(".cowNumberForm").val();
  var selectGet = $("#countries").val();
  var ImageGet = $(".cowImageForm").attr("data-src");
  var ImageGet_2 = $(".cowImageForm_2").attr("data-src");
  var ImageGet_3 = $(".cowImageForm_3").attr("data-src");
  var ImageGet_4 = $(".cowImageForm_4").attr("data-src");
  var ImageGet_5 = $(".cowImageForm_5").attr("data-src");
  var DescriptionGet = $(".cowDescriptionForm").val();


  validateEmail(emailGet);


  function validateEmail(email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (!emailReg.test(email)) {
      $("input.form-control.cowEmailForm").css("border","1px solid red");
    }
    else if((emailGet=='')&&(nameGet=='')){
      $("input.form-control.cowEmailForm").css("border","1px solid red");
      $("input.form-control.cowNameForm").css("border","1px solid red");
    }
    else if((emailGet=='')||(nameGet=='')){

      if(emailGet==''){
        $("input.form-control.cowEmailForm").css("border","1px solid red");
      }
      else{
        $("input.form-control.cowNameForm").css("border","1px solid red");
      }
    }

      else {

      $(".RightWrap button.form-btn.btn.btn-default")
        .addClass("LoaderForm")
        .prop("disabled", true); // NEW: prevent double submits

      var OrderId = Math.floor((Math.random() * 10000000) + 1);
      $("input.form-control.cowEmailForm").css("border","1px solid #cccccc");
      $("input.form-control.cowNameForm").css("border","1px solid #cccccc");
      setCookie("OrderId", OrderId, 365);
      $.ajax({
        type: 'POST',
        url: 'https://deluxeplumbers.com/leathershopify/postmarkapp/src/cowboy-hats.php',
        data: {ImageGet:(ImageGet),ImageGet_2:(ImageGet_2),ImageGet_3:(ImageGet_3),ImageGet_4:(ImageGet_4),ImageGet_5:(ImageGet_5),OrderId:(OrderId),name:(nameGet),email:(emailGet),phone_number:(numberGet),want_to_make:(selectGet),description:(DescriptionGet)},
        dataType: 'html',
        success: function(response){

          window.location.href = "/pages/thank-you" ;
          var OrderId = getCookie("OrderId");
          $(".hdrbg h3 b").html(OrderId);
        },
        error: function(xhr, status, error) { // NEW: recover gracefully on failure
          $(".RightWrap button.form-btn.btn.btn-default")
            .removeClass("LoaderForm")
            .prop("disabled", false);
          alert("Something went wrong submitting your order. Please try again.");
        }
      })
    }
  }

})